import { Clickable } from '@carvana/merch-components';
import { SyntheticEvent } from 'react';
import { useTileDataContext } from '~/context/srp/TileDataContext';
import FavoriteIcon from './FavoriteIcon';
import withHandleFavorite from './withHandleFavorite';

interface OwnProps {
  handleFavorite: () => void;
}

const FavoriteVehicleComponent = ({ handleFavorite }: OwnProps) => {
  const { tileData } = useTileDataContext();

  const submitFavorite = () => {
    if (!tileData?.stockNumber) {
      return;
    }

    handleFavorite();
  };

  const handleOnClick = (event: SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();
    submitFavorite();
  };

  return (
    <Clickable
      aria-label="Favorite Vehicle"
      className="absolute flex h-44 items-center justify-center pointer-events-auto right-[1px] top-[-2px] w-44"
      // favorite events already handled in FavoritesContext
      data-analytics-id={null}
      data-qa="favorite-vehicle"
      onClick={handleOnClick}
    >
      <FavoriteIcon isFavorite={tileData?.isFavorite ?? false} />
    </Clickable>
  );
};

export default withHandleFavorite(FavoriteVehicleComponent);
